import {useEffect, RefObject} from 'react';

export interface ModalHooksProps {
  modalRef: RefObject<HTMLDivElement>;
  modalContainerRef: RefObject<HTMLDivElement>;
  isOpen: boolean;
  closeOnOutsideClick?: boolean;
  onClose?: () => void;
}

export function useModalCloseOnOutsideClick({
  modalRef,
  modalContainerRef,
  isOpen,
  onClose,
  closeOnOutsideClick,
}: ModalHooksProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // 컴포넌트가 언마운트될 때 스크롤을 다시 활성화
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (isOpen && closeOnOutsideClick && event.target instanceof Node) {
        if (onClose && !modalRef.current?.contains(event.target)) {
          onClose();
        }
      }
    };

    if (isOpen && closeOnOutsideClick && modalContainerRef.current) {
      modalContainerRef.current.addEventListener(
        'mousedown',
        handleOutsideClick,
      );
    }

    return () => {
      modalContainerRef.current?.removeEventListener(
        'mousedown',
        handleOutsideClick,
      );
    };
  }, [isOpen, onClose, modalRef, modalContainerRef, closeOnOutsideClick]);
}
